export const stateSnapshot = {
  title: 'State of Hamro Foolbari',
  subtitle: 'Steering Committee Brief - Phase 0 (Dolkha Feasibility Focus)',
  updatedOn: 'February 8, 2026',
  status: 'In assessment',
  recommendation:
    'Proceed with a focused Dolkha feasibility sprint before final pilot-site commitment.',
};

export const keySignals = [
  {
    label: 'Dolkha school records identified',
    value: '366',
    detail:
      'Derived from district-tagged rows in School Details by Local Level and District, 2076.',
  },
  {
    label: 'Local governments represented',
    value: '9',
    detail:
      'Bhimeshwor, Kalinchok, Gaurishankar, Tamakoshi, Bigu, Sailung, Jiri, Melung, Baiteshwor.',
  },
  {
    label: 'ECD/PPC total trend (historical)',
    value: '169 -> 302',
    detail:
      'Dolkha total increased across 2007-2011 in the consolidated statistics report.',
  },
  {
    label: 'Grade 1 net intake rate (total)',
    value: '87.9 -> 92.2',
    detail: 'Dolkha trend across 2008-09 to 2011-12 in the same report.',
  },
];

export const steeringDecisions = [
  'Approve a 4-week Dolkha feasibility sprint (site, demand, and cost validation).',
  'Confirm pilot decision criteria and weighting for candidate locations.',
  'Authorize a three-scenario 2-year budget (conservative, base, stretch).',
  'Approve local leader recruitment finalization and role start date.',
];

export const risksAndGaps = [
  'Current evidence is strong for direction-setting but not sufficient for final location lock.',
  'Available district datasets are historical; ward-level current demand remains unverified.',
  'Site-level infrastructure and transport feasibility data is not yet complete.',
  'Execution budget sensitivity is not yet signed off.',
];

export const immediateNextSteps = [
  'Shortlist 3-5 Dolkha candidate sites with comparable criteria.',
  'Complete ward-level enrollment demand and out-of-school assessment.',
  'Finalize new-build vs lease/adaptation options with rough-order cost ranges.',
  'Submit final recommendation memo with risk controls to the steering committee.',
];

export const analysisDocuments = [
  {
    label: 'Open Dolkha Feasibility Analysis (Feb 8, 2026)',
    href: 'data/artifacts/Dolkha_Feasibility_Analysis_2026-02-08.md',
  },
  {
    label: 'Open School Details by Local Level and District, 2076',
    href: 'data/artifacts/School_Details_by_Local_Level_and_District_2076.pdf',
  },
  {
    label:
      'Open School Level Educational Statistics of Nepal Consolidated Report, 2011 (2068)',
    href:
      'data/artifacts/School_Level_Educational_Statistics_of_Nepal_Consolidated_Report_2011_2068.pdf',
  },
];
